import { INITIALIZE_FORM } from '../actionTypes';
import { commentAreaActions } from '../reducer';

export default (values) => commentAreaActions[INITIALIZE_FORM](values);
